import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa en repostería?',
    a: '¡Para nada! El manual está diseñado desde cero. Explico cada técnica, temperatura y proceso con un lenguaje sencillo, ideal para principiantes que quieren resultados profesionales.'
  }, {
    q: '¿Cómo recibo el manual?',
    a: 'Es un producto 100% digital. Inmediatamente después de tu pago, recibirás un correo electrónico con el enlace para descargar el PDF. Podrás leerlo en tu celular, tablet, computadora o imprimirlo.'
  }, {
    q: '¿Funciona en mi país? ¿Los ingredientes son fáciles de conseguir?',
    a: 'Sí, las recetas están formuladas con ingredientes universales (harina, mantequilla, azúcar, huevos) que encuentras en cualquier supermercado del mundo. Además, el pago se adapta automáticamente a tu moneda local.'
  }, {
    q: '¿Necesito máquinas costosas?',
    a: 'No. Te enseño a lograr resultados increíbles con herramientas básicas de cocina. El secreto está en la técnica y el método, no en equipos industriales.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream-dark/20" data-id="element-67">
      <div className="max-w-3xl mx-auto" data-id="element-68">
        <div className="text-center mb-12" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-espresso mb-4" data-id="element-70">
            Preguntas Frecuentes
          </h2>
          <p className="text-espresso-light font-sans" data-id="element-71">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-72">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-caramel/10 overflow-hidden" data-id="element-73">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-74">
                <span className="font-bold text-espresso pr-8" data-id="element-75">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-caramel transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-76" />
              </button>
              <AnimatePresence data-id="element-77">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-78">
                    <div className="px-6 pb-5 text-espresso-light font-sans leading-relaxed" data-id="element-79">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}